import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import TuneRoundedIcon from "@mui/icons-material/TuneRounded";
import { BsDownload } from "react-icons/bs";
import { IoMdCheckmark, IoMdRefresh } from "react-icons/io";
import toast from "react-hot-toast";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { RiVipCrownFill } from "react-icons/ri";
import { TbTable } from "react-icons/tb";
import { BsGrid1X2Fill } from "react-icons/bs";
import "../../pages/object-management/object.scss";
import {
  OBJECT_PIN,
  TRANSIT_FORM_LIST,
  TRANSIT_INNER_LIST,
} from "../../constants/routers";
import {
  exportObjectList,
  listObject,
  objectPinPageList,
  uploadBulkobjectHandler,
} from "../../api/actions/object";
import { FaRegFile } from "react-icons/fa";
import Loader from "../../components/common/Common/Loader";
import { useFormik } from "formik";
import { TfiExport } from "react-icons/tfi";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Spinner from "react-bootstrap/Spinner";
import Objectfilter from "../../pages/object-management/objectfilter";
import {
  bulksampledownloadhandler,
  listCategoryDropdown,
  listSubCategoryDropdown,
} from "../../api/actions/category";
import Nodata from "../../components/common/Common/Nodata";
import { Dropdown } from "antd";
import { SlOptions } from "react-icons/sl";
import FilterList from "../../components/common/Common/FilterList";
import { useSaving } from "../../store/SavinContext";
import InfiniteScroll from "react-infinite-scroll-component";
import { FaFileUpload } from "react-icons/fa";
import { MenuSaving } from "../../store/menuContext";
import "../../assets/styles/bulkupload.scss";
import "../../assets/styles/component-styles/dataTable.scss";
import { GoArrowLeft } from "react-icons/go";
import TransitObjectTable from "./TransitObjectTable";
import AsyncSelect from "react-select/async";
import { listRoomDropdown } from "../../api/actions/room";
import {
  clearModuleState,
  getModuleState,
  saveModuleState,
} from "../../indexdb/scrollFreezeIndex";
import "../object-management/blurimage.scss";
import "./transitobject.scss";
import ImageCard from "./ImageCard";

const TransitObject = ({ conservation = false, admin }) => {
  const selectProps = { indeterminate: (isIndeterminate) => isIndeterminate };
  const [data, setData] = useState([]);
  const [toRoom, setToRoom] = useState();
  const [selectedToRoom, setSelectedToRoom] = useState();
  const [reachBottom, setReachBottom] = useState(false);
  const [selectedOption, setSelectedOption] = useState("All");
  const [order, setOrder] = useState(conservation || admin ? "asc" : "desc");
  const [totalRows, setTotalRows] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(25);
  const [update, setUpdate] = useState(false);
  const [pending, setPending] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [sortBy, setSortBy] = useState(conservation || admin ? "priority" : "");
  const [showTable, setShowTable] = useState(conservation ? true : false);
  const [showGrid, setShowGrid] = useState(true);
  const [showUploadodal, setShowUploadmodal] = useState(false);
  const [upload, setUpload] = useState(false);
  const [search, setSearch] = useState("");
  const [selectedContents, setSelectedContents] = useState([]);
  const [justSearched, setJustSearched] = useState(false);
  const [showNoSearch, setShowNoSearch] = useState(false);
  const [isRestoring, setIsRestoring] = useState(false);
  const [progress, setProgress] = useState(0);
  const [count, setCount] = useState();
  const [selectedObjectData, setSelectedObjectData] = useState([]);
  const [isSelectedShow, setIsSelectedShow] = useState(false);
  const [selectedObjectIds, setSelectedObjectIds] = useState([]);
  const [uploadInProgress, setUploadInProgress] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const [room, setRoom] = useState([]);
  const [defaultRoom, setDefaultRoom] = useState([]);
  const [toRoomData, setToRoomData] = useState([]);
  const [toRoomDefault, setToRoomDefault] = useState([]);
  const [category, setCategory] = useState([]);
  const [subCategory, setSubcategory] = useState([]);
  const [defaultSubcategory, setdefaulSubtCateory] = useState([]);
  const [defaultcategory, setDefaultCategory] = useState([]);
  const [objectCount, setObjectCount] = useState(0);
  const [clearAll, setClearAll] = useState(true);
  const [isClearAll, setIsClearAll] = useState(false);
  const [newValue, setNewValue] = useState();
  const [isCollapsed, setIsCollapsed] = useState(
    conservation ? window.innerWidth <= 1249 : window.innerWidth <= 1405
  );
  const [titleSize, setTitleSize] = useState(
    conservation ? window.innerWidth <= 1120 : window.innerWidth <= 1147
  );
  const [isSwal, setIsSwal] = useState({
    show: false,
    id: "",
  });
  const location = useLocation();
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem("user_info"));
  const { isSaving } = useSaving();
  const { menuCollapse } = MenuSaving();
  const hasRestoredFromSession = useRef(false);
  const hasRestoredRef = useRef(false);
  const fromTransitInner = location?.state?.fromTransitInner;
  const MODULE_KEY = "object_transit_list";

  const formik = useFormik({
    initialValues: {
      is_iconic: "",
      hasIconic: false,
      hasNoIconic: false,
      object_name: "",
      is_image: "",
      hasImage: false,
      hasNoImage: false,
      accession_number: "",
      start_date: "",
      end_date: "",
      modified_start_date: "",
      modified_end_date: "",
      selectedUpdateDate: [],
      created_by: "",
      selectedUser: "",
      height_max: "",
      height_min: "",
      width_max: "",
      width_min: "",
      depth_max: "",
      depth_min: "",
      period_start: "",
      period_end: "",
      acquisition_method: "",
      selectedAccuistion: "",
      building: "",
      room: "",
      selectedRoom: "",
      tags: "",
      material_id: "",
      category_id: "",
      selectedDate: "",
      selectedCategory: "",
      primary_category: "",
      selectedSubCategory: "",
      selectedMaterial: [],
      conservation_grade: "",
      is_emergency: false,
      object_assigned: "",
      period: "",
    },
    onSubmit: (values) => {
      hasRestoredRef.current = false;
      setUpdate(!update);
      setPage(1);
      // setIsOpen(false);
    },
  });

  const handleOptionClick = (option) => {
    hasRestoredFromSession.current = false;
    setSelectedOption(option);
    setUpdate(!update);
    setPage(1);
  };

  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
  };

  const refreshHandler = () => {
    hasRestoredRef.current = false;
    formik.resetForm();
    setSearch("");
    setPage(1);
    setSelectedOption("All");
    setSelectedContents([]);
    setUpdate(!update);
    setData([]);
    setHasMore(false);
    setSelectedToRoom(null);
    setSelectedObjectData([]);
    setSelectedObjectIds([]);
    setObjectCount(0);
    setCategory([]);
    setDefaultCategory([]);
    setSubcategory([]);
    setdefaulSubtCateory([]);
  };

  const showTableHandler = () => {
    setShowTable(true);
    setShowGrid(false);
  };

  const showGridHandler = () => {
    setShowGrid(true);
    setShowTable(false);
  };

  const uploadFormik = useFormik({
    initialValues: {
      museum_id: userData.museum,
      file: "",
    },
  });

  const convertBase64 = (resume) => {
    return new Promise((resolve, reject) => {
      if (!(resume instanceof Blob)) {
        reject(new Error("Invalid parameter: Expected a Blob."));
        return;
      }
      const fileReader = new FileReader();
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
      fileReader.readAsDataURL(resume);
    });
  };

  const handleClick = () => {
    document.querySelector(".reference-file")?.click();
  };

  const showHandler = () => {
    setShowUploadmodal(true);
  };

  const hideHandler = () => {
    setShowUploadmodal(false);
  };

  const handlefileChange = (e) => {
    convertBase64(e.target.files[0])
      .then((resp) => {
        uploadFormik.setValues({
          ...uploadFormik.values,
          file: resp,
        });
        setUpload(true);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleSampleDownload = () => {
    bulksampledownloadhandler({ page: 1, file_type: "museum_object" })(
      (response) => {
        if (response?.status) {
          toast.success("Download completed successfully!");
          setShowUploadmodal(false);

          let url = response?.data?.file;
          const fileName = "Object sample CSV.csv";

          if (url) {
            url = url.replace(/^http:\/\//i, "https://");

            if (url.startsWith("blob:")) {
              fetch(url)
                .then((res) => res.blob())
                .then((blob) => {
                  const objectURL = URL.createObjectURL(blob);
                  const a = document.createElement("a");
                  a.style.display = "none";
                  a.href = objectURL;
                  a.setAttribute("download", fileName);
                  document.body.appendChild(a);
                  a.click();
                  URL.revokeObjectURL(objectURL);
                  document.body.removeChild(a);
                })
                .catch(() => toast.error("Failed to fetch file"));
            } else {
              fetch(url)
                .then((res) => res.blob())
                .then((blob) => {
                  const objectURL = URL.createObjectURL(blob);
                  const a = document.createElement("a");
                  a.style.display = "none";
                  a.href = objectURL;
                  a.setAttribute("download", fileName);
                  document.body.appendChild(a);
                  a.click();
                  URL.revokeObjectURL(objectURL);
                  document.body.removeChild(a);
                })
                .catch(() => {
                  const a = document.createElement("a");
                  a.style.display = "none";
                  a.href = url;
                  a.setAttribute("download", fileName);
                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);
                });
            }
          } else {
            toast.error("No file URL provided for download!");
          }
        } else {
          toast.error("File download failed!");
        }
      }
    );
  };

  const refetchOnScroll = (type) => {
    if (formik?.values?.room) {
      if (type === "next") {
        setPage(page + 1);
      }
      listObject({
        sort_by: sortBy,
        search: search,
        order: order,
        page: type === "next" ? page + 1 : page,
        limit: limit,
        museum_id: userData.museum,
        collection_completed: conservation && "True",
        is_information_pending: selectedOption === "catlog" ? true : false,
        conservation_status:
          (selectedOption === "conservation_is_draft" &&
            "in_conditional_assessment") ||
          (selectedOption === "completed" && "in_conservation"),
        collection_is_draft: selectedOption === "Drafts" && true,
        is_iconic:
          selectedOption === "Iconic object"
            ? true
            : false || formik?.values?.is_iconic,
        is_image: formik?.values?.is_image,
        material: formik?.values?.material_id,
        category: formik?.values?.category_id,
        height_max: formik?.values?.height_max,
        height_min: formik?.values?.height_min,
        width_max: formik?.values?.width_max,
        width_min: formik?.values?.width_min,
        depth_max: formik?.values?.depth_max,
        depth_min: formik?.values?.depth_min,
        period_start: formik?.values?.period_start,
        period_end: formik?.values?.period_end,
        transit_room: formik?.values?.room,
        acquisition_method: formik?.values?.acquisition_method,
        created_by: formik?.values?.created_by,
        start_date: formik?.values?.start_date,
        end_date: formik?.values?.end_date,
        is_drive_link: "",
        modified_start_date: formik?.values?.modified_start_date,
        modified_end_date: formik?.values?.modified_end_date,
        tags: formik?.values?.tags,
        conservation_grade: [1, 2, 3],
        is_emergency: true,
        object_assigned: formik?.values?.object_assigned,
        period: formik?.values?.period,
        primary_category: formik?.values?.primary_category,
        remarks: formik?.values?.remarks,
      })((response) => {
        if (response?.status) {
          setReachBottom(false);
          setPending(false);

          const updatedData = response?.data?.results?.objects.map(
            (conditionItem) => ({
              ...conditionItem,
              is_edit_condition: false,
              isSelected: selectedObjectIds?.includes(conditionItem?.id)
                ? true
                : false,
            })
          );

          const totalCount = response?.data?.count;
          setObjectCount(totalCount);
          setTotalRows(totalCount);

          setData((prev) => {
            const allData = [...prev, ...updatedData];
            setTotalRows(totalCount);

            if (allData.length >= totalCount) {
              setHasMore(false);
              setReachBottom(true);
            } else {
              setHasMore(true);
              setReachBottom(false);
            }
            return allData;
          });
        }
      });
    }
  };

  const searchHandler = (e) => {
    hasRestoredRef.current = false;
    setPage(1);
    const searchValue = e?.target?.value.trimStart();
    searchValue === "" ? setShowNoSearch(false) : setShowNoSearch(true);
    setSearch(searchValue);
    setUpdate(!update);

    setJustSearched(true);
  };

  let isExporting = false;

  useEffect(() => {
    const handleResizeText = () => {
      const width = window.innerWidth;

      if (conservation) {
        setTitleSize(menuCollapse ? width <= 1412 : width <= 1120);
      } else {
        setTitleSize(width <= 1504);
      }
    };

    window.addEventListener("resize", handleResizeText);
    handleResizeText(); // Initial run on mount

    return () => {
      window.removeEventListener("resize", handleResizeText);
    };
  }, [menuCollapse]);

  useEffect(() => {
    if (progress === 100 || progress === 0) {
      setTimeout(() => {
        setUpload(false);
        setUploadInProgress(false);
      }, 300);
    }
  }, [progress]);

  useEffect(() => {
    if (upload === true) {
      setProgress(0);
      setUploadInProgress(true);
      console.log("Starting upload...");
      const progressSimulation = () => {
        setProgress(10);
        setTimeout(() => {
          setProgress(50);
        }, 1000);
        setTimeout(() => {
          setProgress(90);
        }, 1000);
        setTimeout(() => {
          uploadBulkobjectHandler({ values: uploadFormik?.values })(
            (response) => {
              if (response?.status) {
                toast.success("File uploaded successfully!");
                setProgress(100);
                hideHandler();
                setPage(1);
                setUpdate(!update);
              } else {
                toast.error(response?.message);
                setProgress(0);
                const fileInput = document.querySelector(".reference-file");

                if (fileInput) {
                  fileInput.type = "text";
                  fileInput.value = "";
                  fileInput.type = "file";
                }
              }
            }
          );
        }, 2000);
      };
      progressSimulation();
    }
  }, [upload, uploadFormik?.values]);

  useEffect(() => {
    (async () => {
      if (hasRestoredRef?.current) return;
      const savedState = await getModuleState(MODULE_KEY);
      if (savedState) {
        setPending(true);
        hasRestoredRef.current = true;
        setPage(savedState?.selectedPage);
        setCount(savedState?.count);
        setHasMore(savedState?.hasMore);
        setIsSelectedShow(savedState?.isSelectedShow);
        setSearch(savedState?.search);
        formik?.setValues(savedState?.formikValues);
        setSelectedToRoom(savedState?.selectedToroom);
        setSelectedObjectData(savedState?.savedObjectData);
        setSelectedContents(savedState?.selectedContents);
        setObjectCount(savedState?.objectCount);
        const savedObjectIds = savedState?.selectedObjectIds;
        if (savedObjectIds) {
          const updatedData = savedState?.selectedData?.map((obj) => {
            return {
              ...obj,
              is_edit_condition: false,
              isSelected: savedObjectIds
                ? savedObjectIds.includes(obj.id)
                : false,
            };
          });
          setData(updatedData);
          setSelectedObjectIds(savedObjectIds);
        } else {
          setData(savedState?.selectedData);
        }
        setPending(false);
        window.scrollTo(0, savedState?.scrollY);
        await clearModuleState(MODULE_KEY);
      } else {
        if (formik?.values?.room) {
          const typingTimer = setTimeout(() => {
            setJustSearched(true);
            setPage(1);
            setPending(true);
            setHasMore(true);
            listObject({
              sort_by: sortBy,
              search: search,
              order: order,
              collection_completed: conservation && "True",
              page: page,
              limit: limit,
              museum_id: userData.museum,
              is_information_pending:
                selectedOption === "catlog" ? true : false,
              conservation_status:
                (selectedOption === "conservation_is_draft" &&
                  "in_conditional_assessment") ||
                (selectedOption === "completed" && "in_conservation"),
              collection_is_draft: selectedOption === "Drafts" && true,
              is_iconic:
                selectedOption === "Iconic object"
                  ? true
                  : false || formik?.values?.is_iconic,
              is_image: formik?.values?.is_image,
              material: formik?.values?.material_id,
              category: formik?.values?.category_id,
              height_max: formik?.values?.height_max,
              height_min: formik?.values?.height_min,
              width_max: formik?.values?.width_max,
              width_min: formik?.values?.width_min,
              depth_max: formik?.values?.depth_max,
              depth_min: formik?.values?.depth_min,
              period_start: formik?.values?.period_start,
              period_end: formik?.values?.period_end,
              transit_room: formik?.values?.room,
              acquisition_method: formik?.values?.acquisition_method,
              created_by: formik?.values?.created_by,
              start_date: formik?.values?.start_date,
              end_date: formik?.values?.end_date,
              is_drive_link: "",
              modified_start_date: formik?.values?.modified_start_date,
              modified_end_date: formik?.values?.modified_end_date,
              tags: formik?.values?.tags,
              conservation_grade: [1, 2, 3],
              is_emergency: true,
              object_assigned: formik?.values?.object_assigned,
              period: formik?.values?.period,
              primary_category: formik?.values?.primary_category,
            })((response) => {
              if (response?.status) {
                const responseCount = response?.data?.count;
                setObjectCount(responseCount);

                setPending(false);
                setJustSearched(false);
                // if (count?.countChange) {
                //   setCount(response?.data?.count);
                // }

                let updatedData = [];

                const savedObjectIds = JSON.parse(
                  localStorage.getItem("objectIds")
                );

                if (savedObjectIds) {
                  updatedData = response?.data?.results?.objects?.map((obj) => {
                    return {
                      ...obj,
                      is_edit_condition: false,
                      isSelected: savedObjectIds
                        ? savedObjectIds.includes(obj.id)
                        : false,
                    };
                  });

                  setSelectedObjectIds(savedObjectIds);
                  localStorage.removeItem("objectIds");
                } else {
                  updatedData = response?.data?.results?.objects?.map(
                    (conditionItem) => ({
                      ...conditionItem,
                      is_edit_condition: false,
                      isSelected: selectedObjectIds?.includes(conditionItem?.id)
                        ? true
                        : false,
                    })
                  );
                }

                const totalCount = response?.data?.count;
                setCount(totalCount);
                setTotalRows(totalCount);

                setData((prev) => {
                  const allData = updatedData;

                  if (allData.length >= totalCount) {
                    setHasMore(false);
                    setReachBottom(true);
                  } else {
                    setHasMore(true);
                    setReachBottom(false);
                  }

                  return allData;
                });
              }
            });
          }, 300); // Delay execution by 300ms

          return () => {
            clearTimeout(typingTimer); // Clear timeout when dependencies change
          };
        }
      }
    })();
  }, [
    update,
    formik?.values?.category_id,
    formik?.values?.primary_category,
    formik?.values?.room,
  ]);

  useEffect(() => {
    if (selectedContents?.length > 0) {
      setShowNoSearch(true);
    }

    if (search) {
      setShowNoSearch(true);
    }
  }, [selectedContents]);

  const items = [
    {
      key: "1",
      label: showGrid && (
        <div
          style={{ display: "flex", gap: "30px", alignItems: "center" }}
          className="filter-icons"
          onClick={showTableHandler}
        >
          <TbTable />
          <p>View table</p>
        </div>
      ),
    },
    {
      key: "2",
      label: showTable && (
        <div
          style={{ display: "flex", gap: "30px", alignItems: "center" }}
          className="filter-icons"
          onClick={showGridHandler}
        >
          <BsGrid1X2Fill />
          <p>View grid</p>
        </div>
      ),
    },

    {
      key: "3",
      label: (
        <div
          style={{ display: "flex", gap: "30px", alignItems: "center" }}
          className="filter-icons"
          onClick={refreshHandler}
        >
          <IoMdRefresh />
          <p>Refresh</p>
        </div>
      ),
    },
    {
      key: "4",
      label: (
        <div
          style={{ display: "flex", gap: "20px", alignItems: "center" }}
          className="filter-icons"
          onClick={toggleDrawer}
        >
          <TuneRoundedIcon />
          <p>Filter</p>
        </div>
      ),
    },
  ].filter((item) => item.label);

  const isTransitObjectSelectHandler = (selectedObject) => {
    // validation check
    if (!selectedObject?.stability && !selectedObject?.is_emergency) {
      toast.error("This object doesn’t have condition grading yet.");
      return;
    }

    setData((prev) => {
      const updated = prev.map((item) =>
        item.id === selectedObject.id
          ? { ...item, isSelected: !item.isSelected }
          : item
      );

      const isNowSelected = !selectedObject.isSelected;

      // --- HANDLE PERSISTENT SELECTED LIST ---
      setSelectedObjectData((prevSelected) => {
        if (isNowSelected) {
          // ADD IF NOT EXISTS
          const exists = prevSelected.some((i) => i.id === selectedObject.id);
          const updatedObject = { ...selectedObject, isSelected: true };
          if (!exists) return [...prevSelected, updatedObject];
          return prevSelected;
        } else {
          // REMOVE ON DESELECT
          return prevSelected.filter((i) => i.id !== selectedObject.id);
        }
      });

      // keep only IDs
      setSelectedObjectIds((prev) => {
        if (isNowSelected) return [...prev, selectedObject.id];
        return prev.filter((id) => id !== selectedObject.id);
      });

      return updated;
    });
  };

  const toggleAllTransitHandler = () => {
    setData((prev) => {
      const allSelected = prev.every((item) => item.isSelected);

      // Check ungraded
      const ungradedItems = prev.filter(
        (item) => !item?.stability && !item?.is_emergency
      );

      if (ungradedItems.length > 0) {
        toast.error("Some of the objects don’t have condition grading yet.");
      }

      // Build new updated list
      const updated = prev.map((item) => {
        if (!item?.stability && !item?.is_emergency) {
          return { ...item, isSelected: false }; // never select ungraded
        }
        return { ...item, isSelected: !allSelected };
      });

      const newlySelectedItems = updated.filter((i) => i.isSelected);
      const newlySelectedIds = newlySelectedItems.map((i) => i.id);

      // ---- UPDATE PERSISTENT SELECTED LIST ----
      setSelectedObjectData((prevSelected) => {
        if (allSelected) {
          // All were selected → now unselect all
          return prevSelected.filter(
            (s) =>
              // Keep only those that are NOT in current list
              !prev.some((p) => p.id === s.id)
          );
        } else {
          // Selecting all → add only graded items that aren't already added
          const newOnes = newlySelectedItems.filter(
            (item) => !prevSelected.some((s) => s.id === item.id)
          );
          return [...prevSelected, ...newOnes];
        }
      });

      // ---- UPDATE ID LIST ----
      setSelectedObjectIds((prevIds) => {
        if (allSelected) {
          // remove only those ids that exist in this list (unselect all)
          return prevIds.filter((id) => !prev.some((p) => p.id === id));
        } else {
          // selecting → add missing
          return Array.from(new Set([...prevIds, ...newlySelectedIds]));
        }
      });

      return updated;
    });
  };

  const subCategoryChangeHandler = (subCategoryValue) => {
    hasRestoredRef.current = false;
    const subValues = subCategoryValue.map((li) => li.value);
    setPage(1);
    formik?.setValues({
      ...formik?.values,
      selectedSubCategory: subCategoryValue,
      category_id: subValues,
    });
  };

  const primaryCategoryChangeHandler = (primaryCatgoryValue) => {
    hasRestoredRef.current = false;
    if (!primaryCatgoryValue || primaryCatgoryValue.length === 0) {
      formik?.setValues({
        ...formik?.values,
        selectedCategory: [],
        primary_category: [],
        selectedSubCategory: [],
        category_id: [],
      });

      // Clear the dropdown options too
      setSubcategory([]);
      setdefaulSubtCateory([]);
      return; // stop further execution
    }
    const primaryValues = primaryCatgoryValue?.map((li) => li.value);
    setPage(1);
    formik?.setValues({
      ...formik?.values,
      selectedCategory: primaryCatgoryValue,
      primary_category: primaryValues,
    });
  };

  const toRoomChangeHandler = (toRoomValue) => {
    hasRestoredRef.current = false;
    if (toRoomValue?.value === formik?.values?.room) {
      toast.error("From and To locations should never be the same.");
      setSelectedToRoom(null);
      return;
    }

    hasRestoredRef.current = false;
    setToRoom(toRoomValue?.value);
    setSelectedToRoom(toRoomValue);
  };

  const onRoomchangeHandler = (value) => {
    hasRestoredRef.current = false;

    if (value.value === selectedToRoom?.value) {
      toast.error("From and To locations should never be the same.");
      return;
    }
    setSelectedObjectData([]);
    setSelectedObjectIds([]);
    setPage(1);
    formik?.setValues({
      ...formik?.values,
      room: value?.value,
      selectedRoom: value,
    });
  };

  let typingTimerToroom;

  const toRoomLoadOptionHandlerTransit = (inputValue) => {
    return new Promise((resolve, reject) => {
      clearTimeout(typingTimerToroom);
      typingTimerToroom = setTimeout(() => {
        if (inputValue.length >= 1) {
          listRoomDropdown({
            page: 1,
            search: inputValue,
            sort_by: "room_number",
            museum_id: userData?.museum,
          })((response) => {
            if (response?.status) {
              setToRoomData(response?.data);
              resolve(response?.data);
            }
          });
        } else {
          resolve([]);
        }
      }, 300);
    });
  };

  let typingTimerTransit;

  const roomLoadOptionHandlerTransit = (inputValue) => {
    return new Promise((resolve, reject) => {
      clearTimeout(typingTimerTransit);
      typingTimerTransit = setTimeout(() => {
        if (inputValue.length >= 1) {
          listRoomDropdown({
            page: 1,
            search: inputValue,
            sort_by: "room_number",
            museum_id: userData?.museum,
          })((response) => {
            if (response?.status) {
              setRoom(response?.data);
              resolve(response?.data);
            }
          });
        } else {
          resolve([]);
        }
      }, 300);
    });
  };

  let typingTimerPrimaryCategory;

  const categoryLoadOptionHandler = (inputValue) => {
    if (!formik?.values?.room) {
      return Promise.resolve([]);
    }
    return new Promise((resolve, reject) => {
      clearTimeout(typingTimerPrimaryCategory);

      typingTimerPrimaryCategory = setTimeout(() => {
        if (inputValue.length >= 1) {
          listCategoryDropdown({
            page: 1,
            search: inputValue,
            museum_id: userData?.museum,
            is_primary: true,
            transit_location: formik?.values?.room,
          })((response) => {
            if (response?.status) {
              setCategory(response?.data);
              resolve(response?.data);
            }
          });
        } else {
          resolve([]);
        }
      }, 300);
    });
  };

  let typingSubcategory;

  const subcategoryLoadOptionHandler = (inputValue) => {
    // 🚫 If no primary category selected, show no options — no loading
    if (!formik?.values?.primary_category?.length) {
      return Promise.resolve([]);
    }

    // ✅ Otherwise proceed normally
    return new Promise((resolve) => {
      clearTimeout(typingSubcategory);

      typingSubcategory = setTimeout(() => {
        if (inputValue?.length >= 1) {
          listSubCategoryDropdown({
            page: 1,
            search: inputValue,
            museum_id: userData?.museum,
            is_primary: false,
            primary_category: formik?.values?.primary_category,
            sort_by: "category_name",
            transit_location: formik?.values?.room,
          })((response) => {
            if (response?.status) {
              setSubcategory(response?.data);
              resolve(response?.data);
            } else {
              resolve([]);
            }
          });
        } else {
          resolve([]);
        }
      }, 300);
    });
  };

  useEffect(() => {
    listRoomDropdown({
      page: 1,
      sort_by: "room_number",
      museum_id: userData?.museum,
    })((response) => {
      if (response?.status) {
        setRoom(response?.data);
        setToRoom(response?.data);
        setDefaultRoom(response?.data);
        setToRoomDefault(response?.data);
      }
    });
  }, []);

  useEffect(() => {
    if (formik?.values?.room) {
      listCategoryDropdown({
        page: 1,
        limit: 10,
        sort_by: "category_name",
        museum_id: userData?.museum,
        is_primary: true,
        transit_location: formik?.values?.room,
      })((response) => {
        if (response?.status) {
          setCategory(response?.data.sort());
          setDefaultCategory(response?.data);
        }
      });
    }
  }, [formik.values.room]);

  useEffect(() => {
    if (formik?.values?.primary_category?.length > 0) {
      listSubCategoryDropdown({
        page: 1,
        limit: 10,
        sort_by: "category_name",
        museum_id: userData?.museum,
        is_primary: false,
        primary_category: formik?.values?.primary_category,
        transit_location: formik?.values?.room,
      })((response) => {
        if (response?.status) {
          setSubcategory(response?.data.sort());
          setdefaulSubtCateory(response?.data.sort());
        }
      });
    } else {
      setSubcategory([]);
      setdefaulSubtCateory([]);
    }
  }, [formik?.values?.primary_category]);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;

      if (menuCollapse) {
        setIsCollapsed(width <= 1700);
      } else {
        setIsCollapsed(width <= 1470);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Initial check

    return () => window.removeEventListener("resize", handleResize);
  }, [menuCollapse]);

  useEffect(() => {
    if (newValue === "") {
      setCategory(defaultcategory);
      setSubcategory(defaultSubcategory);
      setRoom(defaultRoom);
      setToRoom(toRoomDefault);
    }
  }, [newValue, category, room, subCategory, toRoom]);
  const saveListState = async () => {
    await saveModuleState(MODULE_KEY, {
      formikValues: formik?.values,
      isSelectedShow: isSelectedShow,
      savedObjectData: selectedObjectData,
      selectedObjectIds: selectedObjectIds,
      selectedToroom: selectedToRoom,
      scrollY: window.scrollY,
      selectedPage: page,
      selectedData: data,
      count: count,
      hasMore: hasMore,
      search: search,
      objectCount: objectCount,
      selectedContents: selectedContents,
    });
  };

  const resetHandler = () => {
    hasRestoredRef.current = false;
    formik?.resetForm({
      values: {
        ...formik?.initialValues, // reset all fields to their initial values
        room: formik?.values?.room,
        selectedRoom: formik?.values?.selectedRoom,
        category_id: formik?.values?.category_id,
        selectedSubCategory: formik?.values?.selectedSubCategory,
        primary_category: formik?.values?.primary_category,
        selectedCategory: formik?.values?.selectedCategory,
      },
    });
    setUpdate(!update);
    setSelectedContents([]);
  };

  const selectedDatalength = data?.filter((item) => item.isSelected).length;

  return (
    <>
      <section
        style={{ paddingTop: "50px" }}
        className="dashboard appraisal-management light-wrapper dark-wrapper"
      >
        <Objectfilter
          setClearAll={setClearAll}
          setIsClearAll={setIsClearAll}
          resetHandler={resetHandler}
          fromTransit={true}
          setPage={setPage}
          conservation={true}
          assign={true}
          // condition={true}
          iconic={true}
          reference={true}
          update={update}
          setUpdate={setUpdate}
          selectedContents={selectedContents}
          setSelectedContents={setSelectedContents}
          isOpen={isOpen}
          toggleDrawer={toggleDrawer}
          setIsOpen={setIsOpen}
          formik={formik}
        />
        <div className="category-container mt-2">
          <div
            style={{
              position: !showTable && "sticky",
              zIndex: "1",
              background: "white",
              top: "61px",
              paddingTop: "30px",
              paddingBottom: "20px",
            }}
            className="category-title-row transit-object-title-row"
          >
            <div
              className="list-left"
              // style={{
              //   flexDirection: "row",
              //   alignItems: "center",
              // }}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <div className="add-category-title-row">
                  <div className=" title-row-content">
                    <div
                      className="title-icon "
                      onClick={() => {
                        navigate(
                          `/${
                            userData.museum_name
                              ? userData?.museum_name?.split(" ").join("_")
                              : "Nefos"
                          }/${TRANSIT_FORM_LIST}`
                        );
                      }}
                    >
                      <GoArrowLeft />
                    </div>
                  </div>
                </div>
                <h2
                  className={
                    conservation && menuCollapse && "conservation-title"
                  }
                >
                  Transit objects
                </h2>
              </div>
              <div className="transit-list-select-option">
                <div className="transit-asnycselect">
                  <AsyncSelect
                    className="transit-room-select"
                    onChange={onRoomchangeHandler}
                    value={formik?.values?.selectedRoom}
                    placeholder="From location"
                    defaultOptions={room}
                    loadOptions={roomLoadOptionHandlerTransit}
                    cacheOptions={false}
                    menuPosition="fixed"
                    onInputChange={(inputValue) => {
                      setNewValue(inputValue);

                      if (!inputValue) {
                        // force rerender or set state to refresh default list
                        setRoom(defaultRoom);
                      }
                    }} //
                    styles={{
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 999,
                      }),
                    }}
                    menuPortalTarget={document.body}
                  />

                  <AsyncSelect
                    className="transit-room-select"
                    value={selectedToRoom}
                    onChange={toRoomChangeHandler}
                    placeholder="To location"
                    defaultOptions={toRoom}
                    menuPosition="fixed"
                    loadOptions={toRoomLoadOptionHandlerTransit}
                    onInputChange={(inputValue) => {
                      setNewValue(inputValue);

                      if (!inputValue) {
                        // force rerender or set state to refresh default list
                        setToRoom(toRoomDefault);
                      }
                    }} //
                    styles={{
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 999,
                      }),
                    }}
                    menuPortalTarget={document.body}
                  />
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      alignItems: "center",
                    }}
                  >
                    <div
                      className={
                        !isSelectedShow
                          ? "object-count-box-active"
                          : "object-count-box"
                      }
                      onClick={() => {
                        setIsSelectedShow(false);
                      }}
                    >
                      <p>
                        {`Number of objects : `}
                        <span>{objectCount}</span>
                      </p>
                    </div>
                    <div
                      className={
                        isSelectedShow
                          ? "object-count-box-active"
                          : "object-count-box"
                      }
                      onClick={() => setIsSelectedShow(true)}
                    >
                      <p>
                        Selected items: <span>{selectedObjectData.length}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="transit-select-and-option-wrapper-container">
              <div className="transit-list-select-option">
                <div className="transit-asnycselect">
                  <AsyncSelect
                    isMulti
                    className="transit-category-select"
                    placeholder="Primary category"
                    defaultOptions={category}
                    menuPosition="fixed"
                    loadOptions={categoryLoadOptionHandler}
                    value={formik?.values?.selectedCategory}
                    onChange={primaryCategoryChangeHandler}
                    onInputChange={(inputValue) => {
                      setNewValue(inputValue);

                      if (!inputValue) {
                        // force rerender or set state to refresh default list
                        setCategory(defaultcategory);
                      }
                    }} //
                    styles={{
                      valueContainer: (base) => ({
                        ...base,
                        maxHeight: 60,
                        overflowY: "auto",
                      }),
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999, // make sure it sits on top of everything
                      }),
                    }}
                    menuPortalTarget={document.body}
                  />
                  <AsyncSelect
                    isMulti
                    className="transit-subcategory-select"
                    placeholder="Subcategory"
                    value={formik?.values?.selectedSubCategory}
                    onChange={subCategoryChangeHandler}
                    loadOptions={subcategoryLoadOptionHandler}
                    defaultOptions={subCategory}
                    menuPosition="fixed"
                    onInputChange={(inputValue) => {
                      setNewValue(inputValue);

                      if (!inputValue) {
                        // force rerender or set state to refresh default list
                        setSubcategory(defaultSubcategory);
                      }
                    }} //
                    styles={{
                      valueContainer: (base) => ({
                        ...base,
                        maxHeight: 60,
                        overflowY: "auto",
                      }),
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999, // make sure it sits on top of everything
                      }),
                    }}
                    menuPortalTarget={document.body}
                  />
                </div>
              </div>
              <div
                className={`category-filter-wrapper transit-category-filter-wrapper`}
              >
                {data?.length > 0 && (
                  <div className="select-all-transit">
                    <p onClick={toggleAllTransitHandler}>
                      {selectedDatalength === data.length
                        ? "Deselect all"
                        : "Select all"}
                    </p>
                  </div>
                )}

                <div>
                  <Form.Control
                    style={{
                      backgroundColor: "#EFF0F0",
                      borderRadius: "22px",
                      minWidth: "200px",
                    }}
                    placeholder="Search"
                    value={search}
                    onChange={searchHandler}
                  />
                </div>

                <div
                  style={{ display: "flex", gap: "10px" }}
                  className="show-option"
                >
                  <Tooltip title="Reset">
                    <div className="filter-icons" onClick={refreshHandler}>
                      <IoMdRefresh />
                    </div>
                  </Tooltip>
                  <Tooltip title="Filter">
                    <div className="filter-icons" onClick={toggleDrawer}>
                      <TuneRoundedIcon />
                    </div>
                  </Tooltip>
                </div>

                {selectedObjectData.length > 0 && (
                  <div
                    style={{ display: "flex", gap: "10px" }}
                    className="show-option"
                  >
                    {" "}
                    <div
                      className="filter-icons submit-transit"
                      onClick={() => {
                        if (!selectedToRoom) {
                          toast.error(`Select "to location" before submit`);
                          return;
                        }

                        saveListState();

                        // localStorage.setItem("isTransit", true);
                        // if (search) {
                        //   localStorage.setItem("search", search);
                        // }
                        // localStorage.setItem(
                        //   "selectedToRoom",
                        //   JSON.stringify(selectedToRoom)
                        // );
                        // localStorage.setItem(
                        //   "formikValues",
                        //   JSON.stringify(formik?.values)
                        // );
                        // localStorage.setItem(
                        //   "objectCount",
                        //   selectedObjectCount.toString()
                        // );
                        // localStorage.setItem(
                        //   "objectIds",
                        //   JSON.stringify(selectedObjectIds)
                        // );

                        navigate(
                          `/${
                            userData.museum_name
                              ? userData?.museum_name?.split(" ").join("_")
                              : "Nefos"
                          }/${TRANSIT_INNER_LIST}`,
                          {
                            state: {
                              transitSelectedDatas: {
                                objectIds: selectedObjectIds,
                                fromLocation: formik?.values?.selectedRoom,
                                toLocation: selectedToRoom,
                                primaryCategory:
                                  formik?.values?.selectedCategory,
                                subCategory:
                                  formik?.values?.selectedSubCategory,
                              },
                            },
                          }
                        );
                      }}
                    >
                      <p>Submit</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {selectedContents?.length > 0 && !showTable ? (
            <div
              className="filter-list-container-transit"
              style={{
                backgroundColor: "white",
                position: "sticky",
                zIndex: "8",
                paddingTop: showGrid && "20px",
                paddingBottom: showGrid ? "20px" : "10px",
              }}
            >
              <FilterList
                setIsClearAll={setIsClearAll}
                resetHandler
                hasRestoredRef={hasRestoredRef}
                setData={setData}
                setToRoom={setToRoom}
                fromTransit={true}
                hasRestoredFromSession={hasRestoredFromSession}
                setPage={setPage}
                update={update}
                setUpdate={setUpdate}
                formik={formik}
                setIsOpen={setIsOpen}
                setSelectedContents={setSelectedContents}
                selectedContents={selectedContents}
              />
            </div>
          ) : (
            <FilterList
              setIsClearAll={setIsClearAll}
              hasRestoredRef={hasRestoredRef}
              setData={setData}
              fromTransit={true}
              setToRoom={setToRoom}
              hasRestoredFromSession={hasRestoredFromSession}
              setPage={setPage}
              update={update}
              setUpdate={setUpdate}
              formik={formik}
              setIsOpen={setIsOpen}
              setSelectedContents={setSelectedContents}
              selectedContents={selectedContents}
            />
          )}
          <div className="dataTable-wrapper location-list">
            {pending ? (
              <Loader admin={admin} />
            ) : (
              <>
                {isSelectedShow ? (
                  /* ================================
         SELECTED OBJECT VIEW
      ================================= */
                  selectedObjectData?.length === 0 ? (
                    <Nodata tranistSelect={true} />
                  ) : (
                    <ResponsiveMasonry
                      columnsCountBreakPoints={{
                        300: 2,
                        500: 3,
                        700: 4,
                        900: 5,
                      }}
                      className="masonry-box"
                    >
                      <Masonry gutter="15px">
                        {selectedObjectData?.map((image) => (
                          <ImageCard
                            key={image.id}
                            image={image}
                            admin={admin}
                            sortBy={sortBy}
                            order={order}
                            limit={limit}
                            count={count}
                            selectedOption={selectedOption}
                            data={data}
                            page={page}
                            selectedContents={selectedContents}
                            formik={formik}
                            location={location}
                            userData={userData}
                            conservation={conservation}
                            search={search}
                            onSelect={isTransitObjectSelectHandler}
                          />
                        ))}
                      </Masonry>
                    </ResponsiveMasonry>
                  )
                ) : (
                  /* ================================
         NORMAL OBJECT LIST VIEW
      ================================= */
                  <>
                    {!pending &&
                      data.length === 0 &&
                      showGrid &&
                      !conservation && (
                        <Nodata fromTransit={true} globalData={showNoSearch} />
                      )}

                    <InfiniteScroll
                      dataLength={data?.length}
                      next={() => refetchOnScroll("next")}
                      hasMore={hasMore}
                      endMessage={
                        !conservation &&
                        showGrid &&
                        data.length > 0 && (
                          <p
                            style={{
                              textAlign: "center",
                              padding: "1rem",
                              color: "gray",
                            }}
                          >
                            <b>You have seen it all</b>
                          </p>
                        )
                      }
                    >
                      {showGrid && !conservation && (
                        <ResponsiveMasonry
                          columnsCountBreakPoints={{
                            300: 2,
                            500: 3,
                            700: 4,
                            900: 5,
                          }}
                          className="masonry-box"
                        >
                          <Masonry gutter="15px">
                            {data?.map((image) => (
                              <ImageCard
                                key={image.id}
                                image={image}
                                admin={admin}
                                sortBy={sortBy}
                                order={order}
                                limit={limit}
                                count={count}
                                selectedOption={selectedOption}
                                data={data}
                                page={page}
                                selectedContents={selectedContents}
                                formik={formik}
                                location={location}
                                userData={userData}
                                conservation={conservation}
                                search={search}
                                onSelect={isTransitObjectSelectHandler}
                              />
                            ))}
                          </Masonry>
                        </ResponsiveMasonry>
                      )}
                    </InfiniteScroll>

                    {hasMore && showGrid && (
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <Spinner animation="border" />
                      </div>
                    )}
                  </>
                )}
              </>
            )}

            {showTable &&
              (data?.length > 0 ? (
                <TransitObjectTable
                  count={count}
                  pending={pending}
                  fetchObjectList={refetchOnScroll}
                  hasMore={hasMore}
                  setJustSearched={setJustSearched}
                  justSearched={justSearched}
                  setReachBottom={setReachBottom}
                  reachBottom={reachBottom}
                  search={search}
                  selectedContents={selectedContents}
                  formik={formik}
                  order={order}
                  setOrder={setOrder}
                  sortBy={sortBy}
                  setSortBy={setSortBy}
                  admin={admin}
                  conservation={conservation}
                  selectedOption={selectedOption}
                  setSelectedOption={setSelectedOption}
                  showGrid={showGrid}
                  setShowGrid={setShowGrid}
                  showTable={showTable}
                  setShowTable={setShowTable}
                  setData={setData}
                  data={data}
                  page={page}
                  limit={limit}
                  setLimit={setLimit}
                  setPage={setPage}
                  setTotalRows={setTotalRows}
                  totalRows={totalRows}
                  selectedRows={selectedRows}
                  setSelectedRows={setSelectedRows}
                  update={update}
                  setUpdate={setUpdate}
                  selectProps={selectProps}
                  isSwal={isSwal}
                  setIsSwal={setIsSwal}
                />
              ) : (
                !pending && <Nodata globalData={showNoSearch} />
              ))}
          </div>
        </div>
      </section>
      <Modal className="bulk_modal" show={showUploadodal} onHide={hideHandler}>
        <Modal.Header
          className="detail-view-header"
          style={{ height: "2vh" }}
          closeButton
        >
          <Modal.Title style={{ fontWeight: "bold" }}>Bulk upload </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <div className="modal_body">
              <div className="main_div">
                <div className="sample_div">
                  <div onClick={handleSampleDownload}>
                    <div className="outline_div">
                      {" "}
                      {/*onClick={downloadHandler}   */}
                      <BsDownload size={30} color="rgb(25, 30, 135)" />
                      <div className="h2_div4">
                        <h2 style={{ fontSize: "13px" }}>Sample CSV</h2>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="upload_div" onClick={handleClick}>
                  <label htmlFor="file"></label>
                  <div className="outline_div">
                    <TfiExport size={30} color="rgb(25, 30, 135)" />
                    <div className="h2_div2">
                      <h2 style={{ fontSize: "13px" }}>Upload CSV</h2>
                    </div>
                    <input
                      type="file"
                      className="reference-file"
                      style={{ display: "none" }}
                      name={`reference`}
                      onChange={handlefileChange}
                      accept=".xlsx, .xls,.csv"
                      isInvalid={null}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Form>
          {uploadInProgress ? (
            <Box sx={{ width: "100%" }}>
              <LinearProgress variant="determinate" value={progress} />
            </Box>
          ) : (
            ""
          )}
        </Modal.Body>
      </Modal>
      {/* <DeleteSweetAlert handleDelete={handleDelete} isSwal={isSwal} setIsSwal={setIsSwal} /> */}
    </>
  );
};

export default TransitObject;
